//components
import React from "react";
import "../../../Resources/Styles/fonts.scss";
import CustomSpinner from "../../Spinner/Spinner";
import { Modal } from "../../CustomModal/Modal";
import ShowList from "./ShowList/ShowList";
import Button from '@material-ui/core/Button';

//actions
import DashBordAction from "../../Dashboard/DashboardAction";

//styling
import "../../../Resources/Styles/fonts.scss";
import "./ManageList.scss";

//material ui
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";

//images
import noCareGiver from "../../../Resources/Images/ic_no_data_loved_ones.png";
import noLovedOnes from "../../../Resources/Images/ic_no_data_caregivers.png";

//constants
import { Strings } from "../../../Resources/Strings/i18n";
import { OperationStatus } from "../../../Communication/Constants";

class ManageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabIndex: "1",
      showSpinner: false,
      showErrorModal: false,
      showSuccessModal: false,
      anchorEl: null
    };
    this.DashBordAction = new DashBordAction();
  }

  careGiverHandler = () => {
    this.setState({ selectedTabIndex: "2" });
  };
  careGiverHandler1 = () => {
    const updateUserList = this.props.userList;
    let pendingInvitee = updateUserList.invitees.monitoring_users.map(
      (user) => {
        return { ...user, status: Strings("Pending") };
      }
    );

    let ApprovedInvitee = updateUserList.monitoring_users.map((user) => {
      return { ...user, status: Strings("Approved") };
    });
    return [...pendingInvitee, ...ApprovedInvitee];
  };
  lovedOneHandler = () => {
    this.setState({ selectedTabIndex: "1" });
  };

  lovedOneHandler1 = () => {
    const updateUserList = this.props.userList;
    let pendingInvitee = updateUserList.invitees.monitored_users.map((user) => {
      return { ...user, status: Strings("Pending") };
    });

    let ApprovedInvitee = updateUserList.monitored_users.map((user) => {
      return { ...user, status: Strings("Approved") };
    });

    return [...pendingInvitee, ...ApprovedInvitee];
  };
  
  handleRemove = (user) => {
    this.setState({
      showSpinner: true
    })
    if(user.subscription) {
      this.DashBordAction.removeConnectionAction({connection_id: user.subscription.client_user_mapping}, actionCallback=> {
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.setState({
            showSuccessModal: true,
            showSpinner: false
          })
        }      
        else {
          this.setState({
            errorMessage: actionCallback.error.errorMessage,
            showErrorModal: true,
            showSpinner: false
          })
        }
      })
    }
    else {
      this.setState({
        errorMessage: Strings("ERROR_CONN_NOT_FOUND"),
        showErrorModal: true,
        showSpinner: false
      })
    }
  }
  render() {
    const lovedOnes = this.lovedOneHandler1();
    const careGiver = this.careGiverHandler1();
    return (
      <div className="ManageList">
        {this.state.showSpinner ?
          <CustomSpinner showModal={this.state.showSpinner} />
          :
          null
        }
        
        {this.state.showErrorModal ?
          <Modal
            show={this.state.showErrorModal}
            handleClose={this.hideModal}
            parent={"exitsession"}
          >
            {
              <div>
                <div className="errorOtp">
                  <div className="errorModal">
                    <div className="modalTitle">
                      <p id="errorTitle">
                        <span id="errorText">{Strings("Error")}</span>
                        {Strings("ErrorOccurred")}
                      </p>
                    </div>
                    <div className="errorContainer">
                      <div className="errorContent">
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                    <Button
                      className="errorBtn"
                      onClick={() => this.setState({ showErrorModal: false }) }
                    >
                      {Strings("OK")}
                    </Button>
                  </div>
                </div>
              </div>
            }
          </Modal>
          :
          null
        }
        {this.state.showSuccessModal ?
          <Modal
            show={this.state.showSuccessModal}
            handleClose={this.hideModal}
            parent={"exitsession"}
          >
            {
              <div>
                <div className="successOtp">
                  <div className="successModal">
                    <div className="modalTitle">
                      <p id="successTitle">
                        <span id="successText">{Strings("Success!")}</span>
                      </p>
                    </div>
                    <div className="successContainer">
                      <div className="successContent">
                        <p>{Strings("ConnectionRemovedSuccess")}</p>
                      </div>
                    </div>
                    <Button
                      className="successBtn"
                      onClick={() => this.setState({ showSuccessModal: false }) }
                    >
                      {Strings("Ok")}
                    </Button>
                  </div>
                </div>
              </div>
            }
          </Modal>
          :
          null
        }

        <p className="heading">{Strings("Manage")}</p>
        <div className="manage_Tag">
          <div
            className={
              this.state.selectedTabIndex === "1"
                ? "lovedOneTab selectedlovedOneTab"
                : "lovedOneTab"
            }
            onClick={this.lovedOneHandler}
          >
            <Chip
              label={Strings("MyLovedOnes")}
              avatar={<Avatar>{lovedOnes.length}</Avatar>}
            />
          </div>
          <div
            className={
              this.state.selectedTabIndex === "2"
                ? "careGiverTab selectedcareGiverTab"
                : "careGiverTab"
            }
            onClick={this.careGiverHandler}
          >
            <Chip
              label={Strings("MyCareGivers")}
              avatar={<Avatar>{careGiver.length}</Avatar>}
            />
          </div>
        </div>

        <div className="manage_Content">
          {this.state.selectedTabIndex === "1" ? (
            !lovedOnes.length ? (
              <div className="noLovedOne">
                <div className="noLovedOneImg">
                  <img src={noLovedOnes} alt="noLovedOne" />
                </div>
                <div className="noLovedOneText">
                  <p className="outerText">{Strings("NoLovedOnes")}</p>
                  <p className="innerText">
                   {Strings("NoLovedOnesMessage")}
                  </p>
                </div>
              </div>
            ) : (
              lovedOnes.map((user, index) => {
                return (
                <ShowList 
                  user={user} 
                  index={index}
                  key={index} 
                  handleMenuClick={(e)=>this.handleMenuClick(e)}
                  handleClose={(e)=>this.handleClose(e)}
                  handleRemove={()=>this.handleRemove(user)}
                />)
              })
            )
          ) : null}

          {this.state.selectedTabIndex === "2" ? (
            !careGiver.length ? (
              <div className="noCareGiver">
                <div className="noCareGiverImg">
                  <img src={noCareGiver} alt="noCareGiver" />
                </div>
                <div className="noCareGiverText">
                  <p className="outerText">{Strings("NoCaregivers")}</p>
                  <p className="innerText">
                  {Strings("NoCaregiversMessage")}
                  </p>
                </div>
              </div>
            ) : (
              careGiver.map((user, index) => {
                return (
                  <ShowList 
                    user={user} 
                    index={index}
                    key={index} 
                    handleMenuClick={(e)=>this.handleMenuClick(e)}
                    handleClose={(e)=>this.handleClose(e)}
                    handleRemove={()=>this.handleRemove(user)}
                />)
              })
            )
          ) : null}
        </div>
      </div>
    );
  }
}

export default ManageList;
